export enum StemeXeGroupType {
  None = 0,
  DueDate = 1,
  Project = 2,
  Week = 3,
  People = 4,
  Importance = 5,
  Graph = 3,
  Efforts = 6,
  Applications = 7,
}

export enum StemeXeSortByType {
  DateDescending = 1,
  DateAscending = 4,
}

export enum ActivityViewByType {
  Activity = 0,
  Efforts = 1
}

export enum StemeXeBoradType {
  Opened = 1,
  closed = 0,
}

export enum StemeXeListType {
  Mine = 0,
  Following = 1,
  Backlog = 2,
  User = 3,
  Shared = 4,
  Closed = 5,
  Signed = 6,
  Rejected = 7,
}

export enum ActiveTab {
  Mine = "Mine",
  Following = "Following",
  Backlog = "Backlog",
  User = "User",
  Shared = "Shared",
  Details = "Details",
  Board = "Board",
  Boards = "Boards",
  All = "All",
}

export enum FileType {
  jpg = 0,
  jpeg = 1,
  png = 2,
  gif = 3,
  doc = 4,
  docx = 5,
  xls = 6,
  xlsx = 7,
  pdf = 8,
  mp3 = 9,
  wav = 10,
  mp4 = 11,
  xwav = 12,
  ppt = 13,
  pptx = 14,
  aac = 15,
  abw = 16,
  arc = 17,
  avif = 18,
  avi = 19,
  azw = 20,
  bin = 21,
  bmp = 22,
  bz = 23,
  bz2 = 24,
  cda = 25,
  csh = 26,
  css = 27,
  csv = 28,
  eot = 29,
  epub = 30,
  gz = 31,
  htm = 32,
  html = 33,
  ico = 34,
  ics = 35,
  jar = 36,
  js = 37,
  json = 38,
  jsonid = 39,
  mid = 40,
  midi = 41,
  mjs = 42,
  mpeg = 43,
  mpkg = 44,
  odp = 45,
  ods = 46,
  odt = 47,
  oga = 48,
  ogv = 49,
  ogx = 50,
  opus = 51,
  otf = 52,
  php = 53,
  rar = 54,
  rtf = 55,
  sh = 56,
  svg = 57,
  tar = 58,
  tif = 59,
  tiff = 60,
  ts = 61,
  ttf = 62,
  txt = 63,
  vsd = 64,
  weba = 65,
  webm = 66,
  webp = 67,
  woff = 68,
  woff2 = 69,
  xhtml = 70,
  xml = 71,
  xul = 72,
  zip = 73,
  '3gp' = 74,
  '3g2' = 75,
  '7z' = 76,
  one = 77
}

export enum Definitions {
  Sum = 1,
  Average = 2,
  Last = 3,
}

export enum Conditions {
  LessThan = 1,
  MoreThan = 2,
  Equal = 3,
}

export enum EntityTypes {
  Expectation = 0,
  Goob = 1,
  Tactic = 2,
  CheckPoint = 3,
  KeyPoint = 4,
  KeyResult = 5,
  Measure = 6,
  Indicator = 7,
  Organization = 8,
  Team = 9,
  Risk = 10,
  CollaborationBoard = 11,
  Note = 17,
}

export enum Actions {
  read = 0,
  create = 1,
  edit = 2,
  delete = 3,
  completeActivity = 4,
  cancelActivity = 5,
  sendReminder = 6,
  logActual = 7,
  close = 8,
  reopen = 9,
  approve = 10,
  reassign = 11,
  reject = 12, // reject
  accept = 13,
  plan = 14,
  unplan = 15,
  returnToBacklog = 15,
  share = 16,
  claim = 17,
  stopClaim = 18,
  cancleClaim = 19,
  completeClaim = 20,
  decideLater = 21,
  doToday = 22,
  schedule = 23,
  expandDueDate = 24,
  sign = 25,
  revoke = 26,
  moveToBoard = 27,
  addToBoard = 27,
  logUnderEfforts = 28,
  follow = 29,
  manage = 30,
  unfollow = 31,
  unmanage = 32,
  HealthUnhealthy = 33,
  addToSprint = 34,
}

export enum BackendAllowedActions {
  read = 0,
  create = 1,
  update = 2,
  delete = 3,
  append = 4,
  specialRight = 5,
}

export enum Status {
  Deleted = -1,
  Inactive = 0,
  Active = 1,
  Done = 2, // approved
  Completed = 2, //approved
  Cancelled = 4, //rejected
  InProgress = 5,
  Open = 6,
  StemeXeApproved = 10,
  StemeXeRejected = 11,
  NotStarted = 12,
}

export enum SourceSystem {
  SimpleStrata = "0",
  Esp = "1",
  EngPro = "2",
  OppPro = "3",
  Epm = "4",
  Plannexe = "5",
  Higher = "6",
  Technadopt = "7",
}

export enum DataProviderSourceSystem {
  SimpleStrata = 0,
  Esp = 1,
  EngPro = 2,
  OppPro = 3,
  Epm = 4,
  Plannexe = 5,
  Higher = 6,
  Technadopt = 7,
}


export enum FromTab {
  ScoreCard = "ScoreCard",
  Project = "Project",
  Request = "Request",
  Opportunity = "Opportunity",
  Fix = "Bugs",
  Sprints = "Sprints",
  Roadblock = "Roadblock",
  Higher = "Higher",
  Events = "Events",
  Members = "Members",
  Details = "Details",
  Listing = "Listing",
  Actions = "Actions",
  All = "All",
  Topic = "Technadopt",
}

export enum PlanneXeActivityFor {
  Project = "Project",
  Bug = "Bug"
}

export enum OppProEnums {
  Opportunity = 1,
  Customer = 2,
  Sales = 3,
}

export enum SourceObjectTypeId {
  SimpleStrata = 1,
  Project = 1,
  EngPro = 1,
  BugId = 2,
  Vacancies = 2,
  Opportunity = OppProEnums.Opportunity,
  Customer = OppProEnums.Customer,
  Sales = OppProEnums.Sales,
  SimpleStrata_Board = 1,
  SimpleStrata_Job = 2,
  
  Request = 1,
  Definition = 2,
  ESPDefinition = 1,
  RequestReque = 2,

  OppPro_Opportunity = 1,
  OppPro_Customer = 2,
  OppPro_SalesJob = 3,

  Plannexe_Project = 1,
  Plannexe_Requirement = 2,
  Plannexe_Deliverable = 3,
  Plannexe_Fix = 4,
  Plannexe_Roadblock = 5, //Issue  = 5
  Plannexe_Sprint = 6,
  Plannexe_Risk = 7,
  // Plannexe_Issue = 5,
  Higher_Project = 1,
  Higher_Vacancy = 2,
  Higher_Candidate = 3,

  Technadopt_Topic = 1,
}

export enum SourceObjectTypeLabel {
  SimpleStrata_Board = 'Board',
  SimpleStrata_Job = 'Job',
  Esp_Definition = 'Definition',
  Esp_Request = 'Request',
  OppPro_Opportunity = "Opportunity",
  OppPro_Customer = 'Customer',
  OppPro_SalesJob = "SalesJob",
  Plannexe_Project = "Project",
  Plannexe_Requirement = 'Requirement',
  Plannexe_Deliverable = "Deliverable",
  Plannexe_Fix = 'Fix',
  Plannexe_Roadblock = 'Issue',
  Plannexe_Roadblock_V2 = 'Roadblock',
  Plannexe_Sprint = 'Sprint',
  Plannexe_Risk = 'Risk',
  Higher_Project = "Project",
  Higher_Vacancy = 'Vacancy',
  Higher_Candidate = 'Candidate',
  Technadopt_Topic = 'Topic',
}

export enum FromMode {
  Edit = "edit",
  New = "new",
  Reassign = "reassign",
}

export enum FilterData {
  SelectedFiltersIdsMine = "SelectedFiltersIdsMine",
  SelectedFiltersIdsBacklog = "SelectedFiltersIdsBacklog",
  SearchMine = "SearchMine",
  SearchBacklog = "SearchBacklog",
  SelectedFiltersMine = "SelectedFiltersMine",
  SelectedFiltersBacklog = "SelectedFiltersBacklog",
  isDefultFilterAppliedMine = "isDefultFilterAppliedMine",
  optionNotChangedMine = "optionNotChanged",
  isDefultFilterAppliedBacklog = "isDefultFilterAppliedMine",
  optionNotChangedMineBacklog = "optionNotChanged",
  ScoreCardAllTabSearch = "ScoreCardAllTabSearch",
  ScoreCardMineTabSearch = "ScoreCardMineTabSearch",
  SelectedFilterScoreCardKeyResults = "SelectedFilterScoreCardKeyResults",
  SelectedFilterScoreCardMeasures = "SelectedFilterScoreCardMeasures",
  SelectedFilterScoreCardGrid = "SelectedFilterScoreCardGrid",
  SelectedFilterScoreCardAllVisual = "SelectedFilterScoreCardAllVisual",
  SelectedFilterScoreCardAllHierarchy = "SelectedFilterScoreCardAllHierarchy",
  SelectedFiltersScoreCardPeriod = "SelectedFiltersScoreCardPeriod",
  SelectedFiltersScoreCardPeriodIds = "SelectedFiltersScoreCardPeriodIds",
  ActivityGroupAction = "ss.activityGroupAction",
  ScoreCardActivityGroupAction = "ss.ScoreCardActivityGroupAction",
}

export enum CommonAttachment {
  Expectation_ExpectationId = 1,
  Team_TeamId = 2,
  Risk_RiskId = 3,
  Goob_GoobId = 4,
  KeyResult_KeyResultId = 5,
  Tactic_TacticId = 6,
  Measure_MeasureId = 7,
  Indicator_IndicatorId = 8,
  CheckPoint_CheckPointId = 9,
  KeyPoint_KeyPointId = 10,
  CollaborationBoard_CollaborationBoardId = 11,
  Note = 17,
}

export enum OpportunityTypes {
  Opportunity = 1,
  Customer = 2,
  Sales = 3
}

export enum AttachmentDataType {
  Notes = "Notes",
  Attachments = "Attachments",
  Comments = "Comments",

}

export enum LogDialogType {
  DistributedEfforts = "DistributedEfforts",
  LogEfforts = "LogEfforts",
}

export enum AssigneeStatus {
  Pending = 0,
  Accepted = 1,
  Declined = 2,
}

export enum AssignorStatus {
  Assigned = 0, //pending
  Approved = 1,
  Rejected = 2,
  // Reassigned = 2,
  Reassigned = 3,
}

export enum OwnershipType {
  None = 0,
  Follow = 1,
  Manage = 2,
}
export enum ActivityType {
  Task = 0,
  Deliverable = 1,
  TimeOff = 2,
}

export enum DialogType {
  Task = "task",
  Calendar = "calendar",
  TimeOff = "timeoff",
  Other = "other",
  AIAssistant = "aiAssistant",
  CreateWithAI = "createWithAI",
}

export enum WarningDialogType {
  // ParentDueDateExtendedOpenChild = 0,
  DueDateExtended = 1,
  ParentFinishesEarlier = 2,
  DeletingAnActivityWithChildren = 3,
  DeletingAnActivityWithChildrenAndParent = 4,
  ManualAttempttoMoveChildEarlier = 5,
  ChildDueDateChanged = 6,
  ReturningToBacklogwithChildren = 7,
  ReturningToBacklogwithChildrenAndParent = 8,
  CancelingwithChildren = 9,
  CancelingwithChildrenAndParent = 10,
}

export enum WarningActionType {
  UpdateLinkedActivityStartDate = "Update Linked Activity Start Date",
  KeepLinkedActivitiesDates = "Keep Linked Activities Dates",
  SetDatesManually = "Set Dates Manually",
  LinktoParent = "Link to Parent",
  BreakLinkAndMove = "Break Link & Move",
  RevertDate = "Revert Date",
}

export enum WarningActionTypeEnum {
  UpdateLinkedActivityStartDate = 0,
  LinktoParent = 2,
  KeepLinkedActivitiesDates = 1,
  SetDatesManually = 3,
  BreakLinkAndMove = 4,
  RevertDate = 5,
}